import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import {
    DynamicTable,
    customColumnProps,
} from "@maherunlocker/custom-react-table";
import { useSnapshot } from "valtio";
import classnames from "classnames";

import { store } from "../../../../components/VerticalLayout/store";
import {
    store as saleStore,
    setLocalShop,
    setIsAssociateModalOpened,
    setNumberActiveMultiShop,
    setNumberArchiveMultiShop,
    setIdsLocalShop,
    setIsAssociatedFiscalYear,
    setShopsFiscalYearData,
    setRowsShop,
    setAssociatedFiscalYear,
    setGlobalDataIsUpdated,
} from "../store";

import { ActionColumn } from "./ActionColumn";
import { ConfirmationActiveFiscalYear } from "../ConfirmationActiveFiscalYear";
import { FiscalYearAssociateModal } from "./FiscalYearAssociateModal";
import { ConfirmationUpdate } from "./ConfirmationUpdate";
import { CustomIcons } from "./CustomIcons";
import HistoryModal from "../HistoryModal";

import { CustomMainColorButton } from "@components/Common/CustomMainColorButton";

import "./index.css";
import "@assets/swal.css";
import "@assets/theme.css";
import "react-toastify/dist/ReactToastify.css";
import { useAuthHeader } from "../../../../api/headersKeycloak";

export default function ShopsFiscalOfYear({
    isFiscalYearArchived,
    setIsFiscalYearArchived,
    setLimit,
}: any) {
    const { oneShop, userID, franchiseID } = useSnapshot(store);
    const {
        isAssociateModalOpened,
        isAssociatedFiscalYear,
        globalDataIsUpdated,
        modify,
    } = useSnapshot(saleStore);
    const i18nextLng = localStorage.getItem("i18nextLng") || "fr";
    const uuidUser = localStorage.getItem("uuidUser");
    const { t } = useTranslation();
    const getAuthHeader = useAuthHeader();

    const [rowData, setRowData] = useState<any>({});
    const [filterActive, setLocalFilterActive] = React.useState<boolean>(false);
    const [isShopSelected, setIsShopSelected] = React.useState<boolean>(false);
    const [isModalOpened, setIsModalOpened] = React.useState<boolean>(false);
    const [isHistoryModalOpened, setIsHistoryModalOpened] = React.useState<
        boolean
    >(false);

    const [selectedRows, setSelectedRows] = React.useState<any[]>([]);

    const [dataTable, setDataTable] = React.useState<any>({});

    const urlArchive: string = `${process.env.REACT_APP_API_V2_URL}/settings/general/fiscal_year_archived?userId=${userID}&franchiseId=${franchiseID}&uuidUser=${uuidUser}`;

    const urlActive: string = `${process.env.REACT_APP_API_V2_URL}/settings/general/fiscal_year?userId=${userID}&franchiseId=${franchiseID}&uuidUser=${uuidUser}`;

    let arrayOfCustomColumns: customColumnProps[] = [
        {
            indexOFColumn: 99,
            columnName: t("Actions"),
            customJsx: (e: any) => (
                <CustomIcons
                    e={e}
                    setRowData={setRowData}
                    setDataIsUpdated={setGlobalDataIsUpdated}
                    setIsHistoryModalOpened={setIsHistoryModalOpened}
                    isHistoryModalOpened={isHistoryModalOpened}
                    setSelectedRows={setSelectedRows}
                    isFiscalYearArchived={isFiscalYearArchived}
                    selectedRows={selectedRows}
                />
            ),
            disableFilter: false,
        },
        {
            indexOFColumn: 2,
            columnName: t("Start exercise"),
            customJsx: (e: any) => <NumberFiscalOfYear e={e} />,
            filterName: t("Start exercise"),
            canFilter: true,
        },
    ];

    function NumberActiveAndArchive() {
        let sumActive = 0;
        let sumArchive = 0;
        if (dataTable.data !== undefined) {
            selectedRows.length === 0
                ? dataTable.data.forEach((item: any) => {
                      sumActive =
                          item.numberActive !== undefined
                              ? sumActive + item.numberActive
                              : sumActive;
                      sumArchive =
                          item.numberArchive !== undefined
                              ? sumArchive + item.numberArchive
                              : sumArchive;
                  })
                : selectedRows.forEach((item: any) => {
                      sumActive =
                          item.numberActive !== undefined
                              ? sumActive + item.numberActive
                              : sumActive;
                      sumArchive =
                          item.numberArchive !== undefined
                              ? sumArchive + item.numberArchive
                              : sumArchive;
                  });
            setNumberActiveMultiShop(sumActive);
            setNumberArchiveMultiShop(sumArchive);
        }
    }

    function NumberFiscalOfYear(e: any) {
        return (
            <React.Fragment>
                {e.e.selectedRow?.subRows !== undefined ? (
                    <h6 className="badge__clz mdv_icn_BTcounter">
                        {e.e.selectedRow?.Boutique !== ""
                            ? e.e.selectedRow.subRows?.length
                            : 0}
                    </h6>
                ) : (
                    e.e.selectedRow[t("Start exercise")]
                )}
            </React.Fragment>
        );
    }

    React.useEffect(() => {
        let localShop: string[] = [];
        let idsLocalShop: string[] = [];
        let associatedFiscalYear: any[] = [];
        selectedRows.forEach((el: any) => {
            if (el[t("Shop")] !== "" && el[t("Shop")] !== undefined)
                localShop.push(el.shopId);

            for (let i in el.subRows) {
                idsLocalShop.push(el.subRows[i].Id);
                associatedFiscalYear.push(el.subRows[i]);
            }
        });
        setAssociatedFiscalYear(associatedFiscalYear);
        setRowsShop(selectedRows);
        setIdsLocalShop(idsLocalShop);
        setLocalShop(localShop);
        setIsShopSelected(localShop.length !== 0);
        setShopsFiscalYearData(dataTable);
    }, [selectedRows, dataTable, t]);

    React.useEffect(() => {
        NumberActiveAndArchive();
        // eslint-disable-next-line
    }, [dataTable]);

    return (
        <React.Fragment>
            <div
                style={{
                    display: "grid",
                    minHeight: oneShop ? "650px" : "600px",
                    gridTemplateColumns: "auto",
                    gridColumnGap: "4px",
                    border: 0,
                }}
            >
                <DynamicTable
                    url={isFiscalYearArchived ? urlArchive : urlActive}
                    requestHeader={{
                        "Accept-Language": i18nextLng,
                        ...getAuthHeader,
                    }}
                    setData={setDataTable}
                    canExpand
                    canSelect
                    customSelect
                    setSelectedRows={setSelectedRows}
                    customJsxSideFilterButton={
                        <React.Fragment>
                            <div className="d-flex justify-content-start align-items-center">
                                {modify === true ? (
                                    <>
                                        <CustomMainColorButton
                                            className={`${classnames(
                                                "w-100 ml-3 exf_btn_BTassignFiscalYear",
                                                {
                                                    "not-allowed-icon__clz": isFiscalYearArchived,
                                                }
                                            )}`}
                                            rounded
                                            variant="primary"
                                            disabled={
                                                isShopSelected ? false : true
                                            }
                                            onClick={() => {
                                                setIsAssociateModalOpened(true);
                                                setLocalFilterActive(false);
                                            }}
                                        >
                                            {t("Assign fiscal year")}
                                        </CustomMainColorButton>
                                        <div></div>
                                    </>
                                ) : null}
                            </div>

                            <ActionColumn
                                setIsHistoryModalOpened={
                                    setIsHistoryModalOpened
                                }
                                isHistoryModalOpened={isHistoryModalOpened}
                                selectedRows={selectedRows}
                                setDataIsUpdated={setGlobalDataIsUpdated}
                                isFiscalYearArchived={isFiscalYearArchived}
                                setIsFiscalYearArchived={
                                    setIsFiscalYearArchived
                                }
                                setLimit={setLimit}
                            />
                        </React.Fragment>
                    }
                    canResize
                    showGlobalFilter
                    showFilter
                    canMovedCheckboxLeftOnExpand
                    setLocalFilterActive={setLocalFilterActive}
                    filterActive={filterActive}
                    actionColumn={() => <></>}
                    arrayOfCustomColumns={arrayOfCustomColumns}
                    setDataIsUpdated={
                        setGlobalDataIsUpdated as
                            | React.Dispatch<
                                  React.SetStateAction<number | boolean>
                              >
                            | undefined
                    }
                    dataIsUpdated={globalDataIsUpdated}
                    elevationTable={1}
                    minHeight={oneShop ? "500px" : "450px"}
                    maxHeight={oneShop ? "500px" : "450px"}
                    name="FiscalYear"
                />
            </div>

            <ConfirmationActiveFiscalYear
                setIsModalOpened={setIsModalOpened}
                isModalOpened={isModalOpened}
            />
            {isHistoryModalOpened ? (
                <HistoryModal
                    ids={selectedRows}
                    setIsModalOpened={setIsHistoryModalOpened}
                    isModalOpened={isHistoryModalOpened}
                    isOneShop={false}
                    rowData={rowData}
                    setData={setGlobalDataIsUpdated}
                />
            ) : null}
            {isAssociateModalOpened ? (
                <FiscalYearAssociateModal
                    setData={setGlobalDataIsUpdated}
                    setLimit={setLimit}
                />
            ) : null}

            {isAssociatedFiscalYear ? (
                <ConfirmationUpdate
                    isModalOpened={isAssociatedFiscalYear}
                    setIsModalOpened={setIsAssociatedFiscalYear}
                    setData={setGlobalDataIsUpdated}
                />
            ) : null}
        </React.Fragment>
    );
}
